import React from 'react';
import { Star } from 'lucide-react';
import { SellerReviewDto } from '../../types';

interface ReviewListItemProps {
    review: SellerReviewDto;
}

function relativeTime(iso: string): string {
    const d = new Date(iso);
    const diffMs = Date.now() - d.getTime();
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    if (days < 1) return 'Today';
    if (days < 7) return `${days}d ago`;
    if (days < 30) return `${Math.floor(days / 7)} weeks ago`;
    if (days < 365) return `${Math.floor(days / 30)} months ago`;
    return d.toLocaleDateString();
}

const ReviewListItem: React.FC<ReviewListItemProps> = ({ review }) => {
    const initial = (review.authorDisplayName || '?').charAt(0).toUpperCase();

    return (
        <div className="rounded-2xl border border-[color-mix(in_srgb,var(--accent-color),transparent_65%)] bg-[color-mix(in_srgb,var(--bg-color),white_20%)] p-4">
            <div className="flex items-start justify-between gap-3">
                <div className="flex items-center gap-3 min-w-0">
                    {review.authorAvatarUrl ? (
                        <img
                            src={review.authorAvatarUrl}
                            alt=""
                            className="h-10 w-10 rounded-full object-cover"
                        />
                    ) : (
                        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[color-mix(in_srgb,var(--text-color),transparent_70%)] text-sm font-semibold text-white">
                            {initial}
                        </div>
                    )}
                    <div className="min-w-0">
                        <p className="text-sm font-semibold text-[var(--text-color)] truncate">
                            {review.authorDisplayName}
                        </p>
                        <div className="mt-0.5 flex gap-0.5">
                            {[1, 2, 3, 4, 5].map((n) => (
                                <Star
                                    key={n}
                                    className={`h-3.5 w-3.5 ${
                                        n <= review.stars
                                            ? 'fill-[var(--accent-color)] text-[var(--accent-color)]'
                                            : 'text-[color-mix(in_srgb,var(--text-color),transparent_65%)]'
                                    }`}
                                />
                            ))}
                        </div>
                    </div>
                </div>
                <span className="shrink-0 text-xs text-[color-mix(in_srgb,var(--text-color),transparent_45%)]">
                    {relativeTime(review.created)}
                </span>
            </div>
            {review.comment && (
                <p className="mt-3 text-sm leading-relaxed text-[var(--text-color)]">
                    {review.comment}
                </p>
            )}
            {review.productTitle && (
                <p className="mt-2 text-xs italic text-[color-mix(in_srgb,var(--text-color),transparent_40%)]">
                    Re: {review.productTitle}
                </p>
            )}
        </div>
    );
};

export default ReviewListItem;
